export const CRYPTO_SWAPS_PATH = "/app/crypto-swaps";
export const CRYPTO_SWAPS_HISTORY_PATH = "/app/crypto-swaps/history";
export const CRYPTO_SELL_PATH = "/app/crypto-swaps/sell";
/** The history opened on its sales tab. */
export const CRYPTO_SELL_HISTORY_PATH = "/app/crypto-swaps/history?tab=sells";

export function cryptoSwapOrderPath(orderId: string): string {
  return `${CRYPTO_SWAPS_PATH}/orders/${encodeURIComponent(orderId)}`;
}

export function cryptoSellOrderPath(saleId: string): string {
  return `${CRYPTO_SWAPS_PATH}/sales/${encodeURIComponent(saleId)}`;
}

/** `?order=` opens the history's detail drawer over the list. */
export const ORDER_PARAM = "order";

/** `?sale=` does the same on the sales tab. */
export const SALE_PARAM = "sale";

export const HISTORY_TAB_PARAM = "tab";

export type CryptoHistoryTab = "buys" | "sells";
